import { useAppStore } from '@/lib/store';

export function SidePhotoPrompt() {
  const { frontPhoto, setStep, setCaptureMode } = useAppStore();

  function handleQuick() {
    setCaptureMode('quick');
    setStep('results');
  }

  function handleSide() {
    setCaptureMode('side');
    setStep('capture_side');
  }

  function handleRotation() {
    setCaptureMode('rotation');
    setStep('capture_rotation');
  }

  return (
    <div className="screen items-center justify-center text-center">
      {/* Thumbnail of front photo */}
      {frontPhoto && (
        <div className="mx-auto mb-6 h-32 w-24 overflow-hidden rounded-xl border-2 border-brand-200 shadow-sm">
          <img
            src={frontPhoto}
            alt="Your front photo"
            className="h-full w-full object-cover"
          />
        </div>
      )}

      <h2 className="text-2xl font-bold text-gray-900">
        How accurate do you want?
      </h2>
      <p className="mt-2 text-sm text-gray-500">
        More angles = more accurate circumference measurements.
      </p>

      {/* Three accuracy tiers */}
      <div className="mt-6 w-full space-y-3">
        {/* Precision Scan */}
        <button
          onClick={handleRotation}
          className="w-full rounded-xl border-2 border-brand-500 bg-brand-50 px-4 py-4 text-left transition-colors hover:bg-brand-100"
        >
          <div className="flex items-start gap-3">
            <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-500 text-white">
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </div>
            <div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold text-brand-700">Precision Scan</span>
                <span className="rounded-full bg-brand-100 px-2 py-0.5 text-[10px] font-semibold text-brand-600">BEST</span>
              </div>
              <p className="mt-0.5 text-xs text-gray-500">
                Slow 360° rotation, ~30 seconds. Prop phone on a surface.
              </p>
            </div>
          </div>
        </button>

        {/* Side Photo */}
        <button
          onClick={handleSide}
          className="w-full rounded-xl border-2 border-gray-200 bg-white px-4 py-4 text-left transition-colors hover:border-gray-300 hover:bg-gray-50"
        >
          <div className="flex items-start gap-3">
            <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-600">
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div>
              <span className="text-sm font-bold text-gray-700">Side Photo</span>
              <p className="mt-0.5 text-xs text-gray-500">
                One extra photo. Stand sideways naturally — arms at sides is fine!
              </p>
            </div>
          </div>
        </button>

        {/* Quick */}
        <button
          onClick={handleQuick}
          className="w-full rounded-xl border-2 border-gray-200 bg-white px-4 py-4 text-left transition-colors hover:border-gray-300 hover:bg-gray-50"
        >
          <div className="flex items-start gap-3">
            <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-600">
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div>
              <span className="text-sm font-bold text-gray-700">Quick</span>
              <p className="mt-0.5 text-xs text-gray-500">
                Use front photo only. Fastest, but circumferences are estimated.
              </p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}
